import { render, staticRenderFns } from "./CompanyRank.vue?vue&type=template&id=90db7fda&scoped=true"
import script from "./CompanyRank.vue?vue&type=script&lang=js"
export * from "./CompanyRank.vue?vue&type=script&lang=js"
import style0 from "./CompanyRank.vue?vue&type=style&index=0&id=90db7fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90db7fda",
  null
  
)

export default component.exports